import { connect } from "react-redux";
import CurrentUser from "./CurrentUser";

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.entities.users[state.currentUser.id]
  };
};

const CurrentUserContainer = connect(mapStateToProps)(CurrentUser);

export default CurrentUserContainer;



// WEBPACK FOOTER //
// ./src/CurrentUserContainer.js